import React from "react";
import { Box } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { GraphQL } from "@rpi/openapi-api";
import { useParams } from "react-router-dom";
import { useAuthUser } from "../../../hooks/useAuthUser";
import { EventLogEntry } from "./eventLogs/EventLogEntry";
import { OrderTabContent } from "./OrderTabContent";

type OrderEvent = NonNullable<NonNullable<GraphQL.OrderEventsQuery["orderByIdentifier"]>["orderEvents"]>[number];

const getEventKey = (event: OrderEvent, index: number): string | number => `${event.eventTime}-${index}`;

export const OrderEventLogsTab: React.FC = () => {
  const { customerPublicId, customerOrderId } = useParams();
  const user = useAuthUser();
  const hasOrderIdentifier = !!customerPublicId && !!customerOrderId;

  const { data, isLoading, error } = GraphQL.useOrderEventsQuery(
    {
      orderIdentifier: {
        customerPublicId: customerPublicId ?? "",
        customerOrderId: customerOrderId ?? "",
      },
      isSandbox: user.isSandbox,
    },
    { enabled: hasOrderIdentifier }
  );

  const events = data?.orderByIdentifier?.orderEvents ?? [];

  return (
    <OrderTabContent
      data={events}
      isLoading={isLoading}
      error={error}
      emptyMessage="No events found for this order."
      loadedTestId="order-event-logs-loaded"
    >
      {(events) => (
        <Box sx={{ padding: tokens.spacing[4] }}>
          {events.map((event, index) => (
            <EventLogEntry
              key={getEventKey(event, index)}
              event={event}
              isLastEntry={index === events.length - 1}
              isSuperAdmin={user.is.SUPER_ADMIN}
            />
          ))}
        </Box>
      )}
    </OrderTabContent>
  );
};
